import { inject } from 'mobx-react';
import * as React from 'react';

import { ContextStore, DialogRoute, RouteStore } from 'bernie-core';
import { ErrorBoundary } from 'bernie-view';

import { PropertyReviews } from '@shared-ui/lodging-reviews';
import { RefTarget } from '@shared-ui/ref-context';

import { adaptSearchCriteria } from 'stores/adapters/bex-api/common/search-criteria-adapter';
import { CurrentHotelStore } from 'stores/current-hotel-store';

import { UitkSpacing } from 'uitk-react-spacing';

import { SharedUiPropertyReviewsDialog } from './shared-ui-property-reviews-dialog';
import { SimpleLazyLoadWrapper } from 'components/common/lazy/simple-lazy-load-wrapper';

interface SharedUiPropertyReviewsWrapperProps {
  currentHotel?: CurrentHotelStore;
  routeStore?: RouteStore;
  context?: ContextStore;
}

export const sharedUIReviewsDialog = 'sui-see-all-reviews-dialog';

export const SharedUiPropertyReviewsWrapper: React.FC<SharedUiPropertyReviewsWrapperProps> = inject(
  'currentHotel',
  'routeStore',
  'context'
)(({ currentHotel, routeStore, context }) => {
  const propertyId = currentHotel?.hotelId?.toString();
  const isDated = currentHotel?.searchCriteria?.startDate?.length > 0;
  const searchCriteria = adaptSearchCriteria(context, currentHotel.searchCriteria, false, null);

  const input = React.useMemo(() => {
    if (!propertyId) {
      return null;
    }

    return { propertyId, pagination: { size: 5, startingIndex: 0 }, includeRecentReviews: isDated, searchCriteria };
  }, [propertyId, isDated, searchCriteria]);

  if (!input) {
    return null;
  }
  const onSeeAllReviewsLinkClick = () => {
    routeStore.updateSearch({ pwaDialog: sharedUIReviewsDialog });
  };

  const onDialogClose = () => {
    routeStore.closeDialog(sharedUIReviewsDialog);
  };

  return (
    <ErrorBoundary label="hotel.information.reviews">
      <UitkSpacing margin={{ block: 'six' }}>
        <RefTarget name="Reviews">
          <SimpleLazyLoadWrapper>
            <PropertyReviews inputs={input} onClickLink={onSeeAllReviewsLinkClick} hideManagementResponse={true} />
            <DialogRoute id={sharedUIReviewsDialog}>
              <SharedUiPropertyReviewsDialog onDialogClose={onDialogClose} />
            </DialogRoute>
          </SimpleLazyLoadWrapper>
        </RefTarget>
      </UitkSpacing>
    </ErrorBoundary>
  );
});

SharedUiPropertyReviewsWrapper.displayName = 'SharedUiPropertyReviewsWrapper';
